
































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {ItrackCollection} from '@/helpers'
import DeliveryAuditRequest from '@/model/request/DeliveryAuditRequest'
import ItDateInput from '@/components/itrack/ItDateInput.vue'
import {IResource, ObjectCollection} from 'simpli-web-sdk'

@Component({
  components: {ItDateInput},
})
export default class FilterDeliveryAudit extends Mixins(MixinMember) {
  @Prop({type: Object, required: true}) value!: DeliveryAuditRequest

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }
}
